const SESSION_VAR = 'cmp-ag';

export class ApareceGlobal {
    /* STATIC */
    public static get (): ApareceGlobal {
        let val = sessionStorage.getItem(SESSION_VAR) || '';

        if (!val) {
            sessionStorage.setItem(SESSION_VAR, '1');
        }

        return new ApareceGlobal(val);
    }

    /* INSTANCE */
    private constructor(private readonly _key: string) {
    }

    public get key(): string {
        return this._key;
    }
}
